import ContactForm from '../ContactFrom'
import sIcon1 from '@images/contact/location.webp'
import sIcon2 from '@images/contact/mail.webp'
import sIcon3 from '@images/contact/phone-call.webp'
import React, { useContext } from 'react';
import { LanguageContext } from '../../index';

const ContactPageContent = () => {

    const { language } = useContext(LanguageContext);

    const content = {
        en: {
            address: "Kraków, ul. Zakopiańska 56 (lokal nr 24)",
            emailPhone: "506 708 825 / 538 368 480",
            webAddress: "salonfabri@gmail.com  fabripodlogi@gmail.com",
        },
        pl: {
            address: "Kraków, ul. Zakopiańska 56 (lokal nr 24)",
            emailPhone: "506 708 825 / 538 368 480",
            webAddress: "salonfabri@gmail.com  fabripodlogi@gmail.com",
        },
    };

    const langContent = content[language] || content.en;

    return (
        <div>
            <section id="g_maP">
                <div id="map" style={{ width: "100%", height: "600px" }}>
                    <embed
                        width="100%"
                        height="100%"
                        frameBorder="0"
                        scrolling="no"
                        marginHeight="0"
                        marginWidth="0"
                        src="https://www.openstreetmap.org/export/embed.html?bbox=19.92750942707062%2C50.01680197343837%2C19.938023686409%2C50.02104846047375&amp;layer=mapnik&amp;marker=50.01892526387247%2C19.932766556739807"
                        style={{ border: "1px solid black" }}
                    ></embed>
                    <br />
                    <small>
                        <a href="https://www.openstreetmap.org/?mlat=50.01893&amp;mlon=19.93277#map=18/50.01893/19.93277&amp;layers=N"></a>
                    </small>
                </div>
            </section>
            <div className="contact-info text-center mb-110">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-4 col-md-6">
                            <div className="info-item">
                                <img src={sIcon1} alt="Icon" />
                                <p>{langContent.address}</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="info-item">
                                <img src={sIcon2} alt="Icon" />
                                <p>{langContent.emailPhone}</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="info-item">
                                <img src={sIcon3} alt="Icon" />
                                <p>{langContent.webAddress}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <section className="contact-page mb-30">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-xl-10 col-lg-11">
                            <div className="contact-form bg-light rmt-0">
                                <ContactForm />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );

}

export default ContactPageContent;
